export default __webpack_public_path__ + "static/media/4.3da77e25.webp";